import { useEffect, useRef } from 'react';
import { withRouter } from 'react-router';
import { store } from '../../redux/store';
import Intercom from '@intercom/messenger-js-sdk';

const ChatPlatformIntercom = ({ location }) => {
    const initNumRef = useRef(0);

    const initIntercom = (info = {}, star = 0, midIntercomInfo = {}, chatwillState = -1) => {
        if (info?.id && initNumRef.current === 0 && chatwillState !== -1) {
            try {
                // 版本名称
                const planInfo = {
                    1: "Free", 2: "Professional", 3: "Premium",
                }
                // 价格
                const myPlan = {
                    2: "$29.99", 4: "$59.99", 8: "$23.99", 9: "$47.99",
                }
                const plan_format = ![2, 3].includes(info.level) ? (planInfo[info.level] || '') : `${planInfo[info.level]} ${myPlan[info.pricing_plan_id]}`;
                console.log(midIntercomInfo);
                const m_int = midIntercomInfo;
                const initParams = Boolean(m_int?.exist && m_int?.intercom_user_jwt) ? {
                    app_id: process.env.REACT_APP_ARMS_ENV === 'prod' ? "t6tndyrj" : "hntligmo",    // 区分测试和线上id  前：正  后：测
                    intercom_user_jwt: m_int.intercom_user_jwt,                             // 用户jwt
                    from_app: "Seoant",                                                     // 来源app名称
                    name: info.shop_owner,                                                    // 商店名称
                    plan: plan_format,                                                      // 套餐 
                    shop_name: info.name,                                                   // 店铺名称`
                    shopify_store_version: info.plan_display_name,                          // 店铺版本
                    review: star ? `${star}-star` : 'no review',                            // 评分
                    review_name: star ? info.shopname : 'no review name',                   // 评价用户名
                    product_info: chatwillState ? 'chatwill' : '',
                    store_handle: (info?.name || '').split('.')[0],                                    // 店铺名称
                } : {
                    user_id: `Seoant_${info.id}`,                                           // app名称_uid
                    email: info.email,                                                      // 邮箱
                    app_id: process.env.REACT_APP_ARMS_ENV === 'prod' ? "t6tndyrj" : "hntligmo",    // 区分测试和线上id  前：正  后：测
                    from_app: "Seoant",                                                     // 来源app名称
                    name: info.shop_owner,                                                    // 商店名称
                    plan: plan_format,                                                      // 套餐 
                    shop_name: info.name,                                                   // 店铺名称`
                    shopify_store_version: info.plan_display_name,                          // 店铺版本
                    review: star ? `${star}-star` : 'no review',                            // 评分
                    review_name: star ? info.shopname : 'no review name',                   // 评价用户名
                    product_info: chatwillState ? 'chatwill' : '',
                    store_handle: (info?.name || '').split('.')[0],                                    // 店铺名称
                }
                Intercom(initParams); // 可反复触发
            } catch (error) {
                console.error('Failed to initialize Intercom with shop info:', error)
            }
            initNumRef.current += 1;
        }
    }

    useEffect(() => {
        initNumRef.current = 0;  // 重置
        store.subscribe(() => {
            const _store = store.getState().public;
            const userInfo = _store.publicInit;
            const chatwillState = _store.chatwill_installed;
            if (!userInfo?.shop_data) {
                return;
            }
            // 触发ic
            const midIntercomInfo = _store.MidIntercomInfo;
            initIntercom(userInfo.shop_data, userInfo.head_data.review, midIntercomInfo, chatwillState);
        })
    }, [location]);

    return <></>
}

export default withRouter(ChatPlatformIntercom);